import { type ILayerProps, type ITextLayerProps } from '@/version-types';
import { type FormatBrushData } from '../types';

// 提取文本格式刷内容 (字号、字体、加粗、斜体、下划线、删除线、项目符号、字体颜色（纯色、渐变）、字间距、行间距、文字特效（包括描边、投影、外发光、背景）、变形效果、透明度、排版方向（横竖版）、对齐方式)
export const extractFormatBrushDataFromLayer = (layer: ILayerProps): FormatBrushData => {
    const { opacity, materialIds } = layer;
    const layerData = layer.data as ITextLayerProps;
    const {
        bold,
        color,
        fontFamily,
        fontSize,
        italic,
        letterSpacing,
        lineSpacing,
        lineThrough,
        listStyle,
        listStyleMaterial,
        textAlign,
        textBackground,
        textGlow,
        textGradient,
        textShadow,
        textStroke,
        textMark,
        underline,
        writingMode,
        shapeExtension,
        texture,
        advancedTextMaterial,
    } = layerData;

    const ret: FormatBrushData = {
        materialIds,
        opacity,
        data: {
            bold,
            color,
            fontFamily,
            fontSize,
            italic,
            letterSpacing,
            lineSpacing,
            lineThrough,
            listStyle,
            listStyleMaterial,
            textAlign,
            textBackground,
            textGlow,
            textGradient,
            textShadow,
            textStroke,
            textMark,
            underline,
            writingMode,
            shapeExtension,
            texture,
            advancedTextMaterial,
        },
    };

    if (advancedTextMaterial) {
        const extraInfo =
            layer.extraInfo && Object.prototype.toString.call(layer.extraInfo) === '[object Object]'
                ? layer.extraInfo
                : {};

        // 优先使用 extraInfo 中的 overrideColorInArtTextCase
        if (extraInfo.overrideColorInArtTextCase) {
            ret.__overrideColorInArtTextCase = extraInfo.overrideColorInArtTextCase;
        } else {
            // 若花字场景下的 textContents 颜色都一致，则将该颜色设置到 ret.__overrideColorInArtTextCase 中
            if (layerData.textContents && layerData.textContents.length > 0) {
                const textContentColors = layerData.textContents.map((item) => item.color);
                const colorSet = new Set(textContentColors);
                if (colorSet.size === 1) {
                    ret.__overrideColorInArtTextCase = textContentColors[0];
                }
            }
        }
    }

    return ret;
};
